import {getCSRF_Token} from "@/fonction/logConnection";

import {callApi} from "./_callApi";

export async function demanderContactFournisseur(
  API: string | undefined,
  idFournisseur: number,
  campagneId: number
): Promise<void> {
  try {
    if (!API) {
      throw new Error("API is not provided.");
    }
    await callApi(
      `${API}/api/coact/v1/demandes-contact`,
      "POST",
      {
        "Content-Type": "application/json",
        "X-CSRF-Token": getCSRF_Token(),
      },
      "include",
      {fournisseur_id: idFournisseur, campagne_id: campagneId}
    );
  } catch (error: any) {
    throw new Error(error?.message);
  }
}

export async function validateContactFournisseur(
  API: string | undefined,
  idDemandeContact: number
): Promise<void> {
  try {
    if (!API) {
      throw new Error("API is not provided.");
    }
    await new Promise(resolve => setTimeout(resolve, 1000));
    await callApi(
      `${API}/api/coact/v1/demandes-contact/${idDemandeContact}/valider`,
      "POST",
      {
        "Content-Type": "application/json",
        "X-CSRF-Token": getCSRF_Token(),
      },
      "include",
      {},
      false,
      false
    );
  } catch (error: any) {
    throw new Error(error?.message);
  }
}
